import { Tab } from 'BreetComponents';
import { useSavedWalletAddressApi, useWithdrawUsdRequestContext } from 'BreetHooks';

import { tabs } from '../../DialogWithdrawUsdRequest.helpers';
import { DialogWithdrawUsdWalletAddressesSaved } from '../walletAddresses';
import FormWalletAddress from './wallet-address/Form.WalletAddress';

const FormDestination = () => {
	const { tabProps } = useWithdrawUsdRequestContext();

	const { isSavedWalletAddressesEmpty } = useSavedWalletAddressApi();

	return (
		<div className='payment-request-form_usdDestination'>
			<Tab.Header
				{...tabProps}
				tabs={tabs as unknown as string[]}
			/>

			<Tab.Body isActive={tabProps.isActiveTab('Send Crypto')}>
				{isSavedWalletAddressesEmpty ? <FormWalletAddress /> : <DialogWithdrawUsdWalletAddressesSaved />}
			</Tab.Body>
		</div>
	);
};

export default FormDestination;
